import { render, staticRenderFns } from "./IndustryConference.vue?vue&type=template&id=72480fb2&scoped=true"
import script from "./IndustryConference.vue?vue&type=script&lang=js"
export * from "./IndustryConference.vue?vue&type=script&lang=js"
import style0 from "./IndustryConference.vue?vue&type=style&index=0&id=72480fb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72480fb2",
  null
  
)

export default component.exports